import { Program, ProgramTimelineData, ProgramTimelineMultiColumn, ProgramTimelineMultiColumnProgram, ProgramTimelineMultiSession, ProgramTimelineSingleColumn, ProgramTimelineSingleSession } from '../../../../globals/store/programs.data';
import { date_id } from '../../../../globals/helpers/helpers';
import { DAY_MS } from '../../../../globals/helpers/constants';
import { JoiEvent } from '../../../../globals/store/events.data';
import { ExhibitorStand, ExhibitorWithStand } from '../../../../globals/store/exhibitors.data';
import { TimeHelper } from '../../../../globals/helpers/time.helper'; // 'src/app/services/helpers/time.helper';
import { exhibitorToStand, makeProgramText, time_to_min } from 'globals/helpers/helpers';
export { exhibitorToStand }

export const transformExhibitorStandToId = ({  })


export const getStandIdsByExhibitorIds = (exhibitorStands: { [sId: string]: ExhibitorStand }): { [eId: string]: string[]} => {
  const standIdsByExhibitorIds: { [eId: string]: string[] } = {}
  Object.values(exhibitorStands).filter(s => s.exhibitorId).forEach(s => {
    if (!standIdsByExhibitorIds[s.exhibitorId]) standIdsByExhibitorIds[s.exhibitorId] = []
    standIdsByExhibitorIds[s.exhibitorId].push(s.id)
  })
  return standIdsByExhibitorIds
}

export const prepareAndGetTimelineData = (programs: Program[], timelineViews: string[], event: JoiEvent): ProgramTimelineData => {
  // mutates programs as well as timelineViews.  Extracted to closer to a pure function to see if there were any dependencies unknown about.  Don't put this back into a class, but definitely could be moved to a different location.

  let single_column: ProgramTimelineSingleColumn[] = [];
  const multiple_column: ProgramTimelineMultiColumn[] = [];
  const performerIdsBySessionIds = {}
  const performerStatusBySessionIds = {}
  const timeHelper = new TimeHelper();

  programs.filter(p => !!p.date).forEach(p => {
    // program_legend
    // single_column & multiple_column
    p.sessions.forEach(day => {
      const d = new Date((new Date(p.date).getTime()) + (+day.day - 1) * DAY_MS)
      const pID = date_id(d);
      const s_idx = single_column.findIndex(pp => pp.id === pID);
      const s_sessions: ProgramTimelineSingleSession[] = [];
      const m_idx = multiple_column.findIndex(pp => pp.id === pID);
      const m_sessions: ProgramTimelineMultiSession[] = [];
      day.sessions.forEach(sess_id => {
        const session = p.sessions_obj[sess_id]
        if (session.type === 'session') {
          const performers = [];
          if (session.performers) {
            session.performers.forEach(pp => {
              performers.push({ name: pp.name, line1: pp.line1 || '', line2: pp.line2 || '' });
            });
          }
          performerIdsBySessionIds[sess_id] = session.performerIds
          performerStatusBySessionIds[sess_id] = session.performerStatus
          const timezoneAbbr = p.timeZoneDetails.abbr
          const utc = d.getTime() + (timeHelper.getMinutes(session.start) * 60 * 1000);
          s_sessions.push({ // WHY CHANGE THE NAMES OF EVERYTHING IN HERE???  Oh well, backwards compatability it is
            start: session.start,
            end: session.end,
            timezoneAbbr,
            performerRoleIds: session.performerRoles || {},
            utc,
            sessionId: sess_id,
            pID: p.id,
            title: session.title,
            description: session.description,
            program_title: p.title,
            venueId: p.venueId || '',
            has_venue: !!p.venueId || (p.labels && !!p.labels.length),
            expanded: 'collapse',
            location: p.location,
            performers: [], // deprecated, will get info from full performers object attached to snapshot
            performerIds: session.performerIds,
            sponsorIds: session.sponsorIds,
            performerStatus: session.performerStatus,
            sess_labels: session.labels || [],
            prog_labels: p.labels || [],
            tags: session.tags || [],
            groupTags: session.groupTags || [],
            programText: makeProgramText(p.title, p.location, event.venues[p.venueId])
          })
          m_sessions.push({
            start: session.start,
            end: session.end,
            timezoneAbbr,
            utc,
            sessionId: sess_id, 
            pID: p.id,
            title: session.title,
            description: session.description,
            performers: [], // deprecated, will get info from full performers object attached to snapshot
            sponsorIds: session.sponsorIds,
            performerIds: session.performerIds,
            performerStatus: session.performerStatus,
            sess_labels: session.labels || [],
            tags: session.tags || [],
            groupTags: session.groupTags || [],
          })
        }
      });

      if (s_idx > -1) {
        single_column[s_idx].sessions = [...single_column[s_idx].sessions, ...s_sessions];
      } else {
        single_column.push({ id: pID, date: d.getTime(), sessions: s_sessions });
      }

      const m_program: ProgramTimelineMultiColumnProgram = {
        pID: p.id, title: p.title, location: p.location, 
        programConfirmed: p.programConfirmed, dateConfirmed: p.dateConfirmed, locationConfirmed: p.locationConfirmed,
        venueConfirmed: p.venueConfirmed, expectedNumber: p.expectedNumber, setup: p.setup, setup_items: p.setup_items,
        venueId: p.venueId, prog_labels: p.labels || [], sessions: m_sessions
      };
      if (m_idx > -1) {
        multiple_column[m_idx].programs.push(m_program);
      } else {
        multiple_column.push({ id: pID, date: d.getTime(), programs: [m_program] });
      }
    })
    single_column.forEach((pg, i) => timelineViews[i] = 'expand');

  })
  single_column = single_column.filter(timeline => timeline.sessions && timeline.sessions.length)
  single_column.forEach(p => {
    p.sessions.sort((s1: ProgramTimelineSingleSession, s2: ProgramTimelineSingleSession) => {
      const diff = time_to_min(s1.start) - time_to_min(s2.start);
      if (diff === 0) {
        return time_to_min(s1.end) - time_to_min(s2.end);
      } else {
        return diff;
      }
    });
  });
  single_column.forEach(p => {
    p.sessions.forEach((s2: ProgramTimelineSingleSession, idx: number) => {
      const s1 = p.sessions[idx - 1]
      if (!s1) return
      if (s1.start === s2.start && s1.end === s2.end) {
        if (s1.class !== 'group') s1.class = 'group-start'
        s2.class = 'group';
      }
    })
  });
  single_column.sort((p1, p2) => p1.date > p2.date ? 1 : -1);
  multiple_column.sort((p1, p2) => p1.date > p2.date ? 1 : -1);

  return { single_column, multiple_column, performerIdsBySessionIds, performerStatusBySessionIds }

}
